<div class="master-filter-container">
    <div class="master-filter-col col-1">
        <p-button
            styleClass="filter-input-btn"
            (click)="op.toggle($event)"
            [label]="chosenPropertyLabel"
            [icon]="updateDropdownIcon(filtersOpenState.estateType)"
            [tooltip]="tooltip"
            tooltipPosition="top"
        />

        @if (hasSelection) {
            <span class="pi pi-times clear-button" (click)="clearEstateTypesSelection()"></span>
        }
        <p-overlayPanel #op (onShow)="onFilterEstateTypeShow()" (onHide)="onFilterEstateTypeHide()">
            <app-cascade-selection
                #cascadeSelection
                [isFilterOpen]="filtersOpenState.estateType"
                firstLevelTitle="{{ 'EstateType' | localize }}"
                (propertySelectionChange)="onPropertySelectionChange($event)"
                (propertyDeselectionChange)="onPropertyDeselectionChange($event)"
            />
        </p-overlayPanel>
    </div>
    <div class="master-filter-col col-2" #filterButton>
        <p-button
            styleClass="filter-input-btn"
            (click)="op2.toggle($event)"
            [label]="chosenPriceLabel"
            [icon]="updateDropdownIcon(filtersOpenState.price)"
        />
        @if (chosenPriceLabel != defaultPriceLabel) {
            <span class="pi pi-times clear-button" (click)="clearSelection(rangeSlider1, rangeSlider2)"></span>
        }
        <p-overlayPanel styleClass="custom-overlay-panel" #op2 (onShow)="onFilterPriceShow()" (onHide)="onFilterPriceHide()">
            <app-range-slider
                #rangeSlider1
                [title]="'filterPrice' | localize"
                [stepInput]="5000"
                [valueMin]="0"
                [valueMax]="2000000"
                suffix=" €"
                type="price"
                (onSubmitForm)="handleMoneyFrom($event)"
                [valueFrom]="moneyFromControl.value"
                [valueTo]="moneyToControl.value"
            />
            <app-range-slider
                #rangeSlider2
                [title]="'filterPriceSquare' | localize"
                [stepInput]="100"
                [valueMin]="0"
                [valueMax]="10000"
                suffix=" €"
                type="priceSquare"
                (onSubmitForm)="handlePricePerSquareMetresFrom($event)"
                [valueFrom]="squareMetrePriceFromControl.value"
                [valueTo]="squareMetrePriceToControl.value"
            />
        </p-overlayPanel>
    </div>
    <div class="master-filter-col col-2">
        <p-button
            styleClass="filter-input-btn"
            (click)="op3.toggle($event)"
            [label]="chosenAreaLabel"
            [icon]="updateDropdownIcon(filtersOpenState.area)"
        />
        @if (chosenAreaLabel != defaultAreaLabel) {
            <span class="pi pi-times clear-button" (click)="clearSelection(rangeSlider3)"></span>
        }
        <p-overlayPanel #op3 (onShow)="onFilterAreaShow()" (onHide)="onFilterAreaHide()" styleClass="custom-overlay-panel">
            <app-range-slider
                #rangeSlider3
                [title]="'Area' | localize"
                [defaultAreaTitle]="'Area' | localize"
                class="filter-container-group"
                type="area"
                [stepInput]="100"
                [valueMin]="0"
                [valueMax]="5000"
                [suffix]="'squareMeter' | localize"
                (onSubmitForm)="handleAreaChanges($event)"
                [valueFrom]="squareMetreAreaFromControl.value"
                [valueTo]="squareMetreAreaToControl.value"
            />
        </p-overlayPanel>
    </div>
    <div class="master-filter-col col-2">
        <p-dropdown
            (onShow)="onFilterOwnershipShow()"
            (onHide)="onFilterOwnershipHide()"
            [options]="ownerships"
            [(ngModel)]="selectedOwnership"
            optionLabel="name"
            [dropdownIcon]="updateDropdownIcon(filtersOpenState.ownership)"
            (ngModelChange)="changeOwnership($event)"
        >
            <ng-template let-ownership pTemplate="item">
                <div class="dropdown-option">
                    <app-svg-icon [icon]="'dot-icon'" size="small" [color]="ownership.color" />
                    <span>{{ ownership.name }}</span>
                </div>
            </ng-template>
            <ng-template let-ownership pTemplate="selectedItem">
                <div class="dropdown-option">
                    <app-svg-icon [icon]="'dot-icon'" size="small" [color]="ownership.color" />
                    <span>{{ ownership?.name }}</span>
                </div>
            </ng-template>
        </p-dropdown>
    </div>

    <div class="master-filter-col col-3 location-field-filter">
        @if (selectedRegions.length > 0) {
            <div class="chips-container">
                @for (region of selectedRegions; track region) {
                    <p-chip [label]="region.label" [removable]="true" (onRemove)="removeRegion(region, $event)"></p-chip>
                }
            </div>
        }

        <div class="filter-input-btn custom-filter-input" (click)="op8.toggle($event)">
            {{ chosenLocationLabel }}

            @if (selectedRegions.length > 0) {
                <span class="pi pi-times clear-button" (click)="clearSelectionLocation()"></span>
            }

            <div class="custom-icon">
                <span
                    data-pc-section="icon"
                    class="p-button-icon p-button-icon-left ng-star-inserted pi pi-chevron-down rotate-icon"
                ></span>
            </div>

            <p-overlayPanel #op8 (onShow)="onFilterLocationShow()" (onHide)="onFilterLocationHide()" [styleClass]="'overlay-map-panel'">
                <app-cascade-selection-location
                    #appCascadeLocation
                    [options]="locationOptions"
                    [isFilterOpen]="filtersOpenState.location"
                    [selectedRegions]="selectedRegions"
                    thirdLevelTitle="Райони"
                    (selectionChange)="handleFilterChange($event)"
                    (regionsChange)="updateSelectedRegions($event)"
                    (locationChange)="onLocationChange($event)"
                ></app-cascade-selection-location>

                <!--                map-->
                <div class="map-container">
                    <app-google-map
                        [height]="'440px'"
                        [width]="'100%'"
                        [center]="center"
                        [zoom]="zoom"
                        [options]="mapOptions"
                        [markers]="markers"
                        [polygons]="polygons"
                        [polygonModels]="polygonModels"
                        (mapInitialized)="onMapInitialized($event)"
                        (polygonClick)="onPolygonClick($event)"
                    />
                </div>
            </p-overlayPanel>
        </div>
    </div>

    <div class="master-filter-col col-2">
        <p-dropdown
            (onShow)="onFilterCompanyShow()"
            (onHide)="onFilterCompanyHide()"
            [options]="companies"
            [(ngModel)]="selectedCompany"
            placeholder="{{ 'AllCompanies' | localize }}"
            optionLabel="name"
            [dropdownIcon]="updateDropdownIcon(filtersOpenState.company)"
        >
            <ng-template let-company pTemplate="item">
                <div class="dropdown-option">
                    <span>{{ company.name }}</span>
                </div>
            </ng-template>
            <ng-template let-company pTemplate="selectedItem">
                <div class="dropdown-option">
                    <span>{{ company?.name }}</span>
                </div>
            </ng-template>
        </p-dropdown>
    </div>

    <div class="master-filter-col col-2 filterResultsBtn-wrapper">
        <app-button
            [text]="'ShowResults' | localize"
            class="filterResultsBtn"
            [fullHeight]="true"
            [fullWidth]="true"
            (onSubmit)="onSubmit()"
        />
    </div>

    <!--Advanced filters------------------------------->
    <div class="master-filter-col advanced-filters">
        <p-button
            styleClass="filter-input-btn"
            (click)="toggleAdvancedFilters()"
            [label]="'AdvancedFilters' | localize"
            class="advanced-toggle"
            [icon]="updateAdvancedFiltersDropdownIcon(filtersOpenState.advancedFilters)"
        />
        <span class="filter-counter">{{ loadedResultsCount }}</span>
    </div>
    @if (filtersOpenState.advancedFilters) {
        <div class="advanced-filters-container">
            <app-advanced-filters
                [ShowApartmentFilters]="ShowApartmentFilters"
                [ShowHouseFilters]="ShowHouseFilters"
                (trueValuesChange)="updateLoadedResultsCount($event)"
                (allValuesCleared)="handleAllValuesCleared()"
            ></app-advanced-filters>
        </div>
    }
</div>
